import React from 'react'
import PropTypes from 'prop-types'

import {
  CompletionCircle,
  CompletionCheckmark,
} from 'components/TieredInterventionUnitCard/component.styles'
import DoneCheckmark from 'components/TieredInterventionUnitCard/assets/checkmark-done-green.svg'
import { COMPLETED_ALT_TEXT } from 'components/TieredInterventionUnitCard/constants'

import {
  UnitV3TrainingCard,
  UnitV3TrainingCardLink,
  UnitV3TrainingDescription,
  UnitV3TrainingText,
  UnitV3TrainingTitle,
} from '../component.styles'

export function UnitV3TrainingCardComponent({
  description,
  isPreview,
  markedComplete = false,
  path,
  title,
}) {
  return (
    <UnitV3TrainingCardLink data-testid="unit-v3-training-card" to={path}>
      <UnitV3TrainingCard>
        {!isPreview && (
          <CompletionCircle
            data-testid="unit-v3-training-completion-circle"
            markedComplete={markedComplete}
          >
            {markedComplete && (
              <CompletionCheckmark
                alt={COMPLETED_ALT_TEXT}
                src={DoneCheckmark}
              />
            )}
          </CompletionCircle>
        )}
        <UnitV3TrainingText>
          <UnitV3TrainingTitle>{title}</UnitV3TrainingTitle>
          <UnitV3TrainingDescription>{description}</UnitV3TrainingDescription>
        </UnitV3TrainingText>
      </UnitV3TrainingCard>
    </UnitV3TrainingCardLink>
  )
}

UnitV3TrainingCardComponent.propTypes = {
  description: PropTypes.string,
  isPreview: PropTypes.bool,
  markedComplete: PropTypes.bool,
  path: PropTypes.string.isRequired,
  title: PropTypes.string,
}
